import "./components.css"
import StoreImg from "../assets/onnize store.jpeg"
import { useNavigate } from "react-router-dom";

const StoreFeedCard = ({ str }) => {
    const navigate = useNavigate()
    return (
        <div className="store-card" onClick={() => navigate(`/b/${str.name}`, { state: {storeData: str } })}>
            {/* Store Name */}
            <h3 className="store-name">{str.name}</h3>
            <div className="store-banner">
                <img
                    src={str?.banner?.url || StoreImg}
                    alt={str?.name || "Store banner"}
                    onError={(e) => { e.target.src = StoreImg; }}
                />
            </div>


            {/* Store Description */}
            <p className="store-description">{str.description}</p>
        </div>
    );
};

export default StoreFeedCard;
